// Types
import { NotificationsState, Notification } from 'types'

// Utils
import { safeLocalStorage as localStorage } from 'utils'

const localStoreInitial = (key: string, def: unknown) => {
  const item = localStorage.getItem(key)
  if (!item || item === '') {
    return def
  }
  return JSON.parse(item)
}

export const initialState: NotificationsState = {
  localSeen: localStoreInitial('localSeenNotifications', []),
  entities: {},
}

export type NotificationsActionTypes =
  | { type: 'NOTIFICATION_REMOVE_LOCAL'; notification: Notification }
  | {
      type: 'CREATE_NOTIFICATION_LOCAL'
      data: Notification
    }

export const reducer = (state: NotificationsState = initialState, action: NotificationsActionTypes): NotificationsState => {
  switch (action.type) {
    case 'NOTIFICATION_REMOVE_LOCAL': {
      const { entities } = state
      delete entities[String(action.notification.localId)]
      return {
        ...state,
        entities,
      }
    }

    case 'CREATE_NOTIFICATION_LOCAL': {
      return {
        ...state,
        entities: {
          ...state.entities,
          [String(action.data.localId)]: action.data,
        },
      }
    }

    default:
      return state
  }
}

export default reducer
